import { ValidationRulePreset } from 'common/Validator/ValidationRules';
import { createImmutableFormValidatorConfig, FormValidatorConfig } from 'common/Validator/Validator';

interface InsuranceFormParams {
  isUsClinic: boolean;
  isPrimaryMember: boolean;
  showHasInsuranceQuestion: boolean;
  hasSelectedNoInsurance: boolean;
  isMemberIdOptional: boolean;
}

const hasSelectedNoInsurance = ({ hasSelectedNoInsurance }: InsuranceFormParams) => hasSelectedNoInsurance;
const isPrimaryMember = ({ hasSelectedNoInsurance, isPrimaryMember }: InsuranceFormParams) =>
  hasSelectedNoInsurance || Boolean(isPrimaryMember);

export const INSURANCE_FORM_VALIDATOR_CONFIG: FormValidatorConfig<InsuranceFormParams> =
  createImmutableFormValidatorConfig([
    {
      field: 'hasInsurance',
      preset: ValidationRulePreset.required,
      shouldIgnore: ({ showHasInsuranceQuestion }) => !showHasInsuranceQuestion,
    },
    {
      field: 'insuranceProvider',
      preset: ValidationRulePreset.insurance,
      shouldIgnore: hasSelectedNoInsurance,
    },
    {
      field: 'insurancePlan',
      preset: ValidationRulePreset.insurance,
      shouldIgnore: ({ isUsClinic, hasSelectedNoInsurance }) => !isUsClinic || hasSelectedNoInsurance,
    },
    {
      field: 'memberId',
      preset: ValidationRulePreset.required,
      shouldIgnore: ({ hasSelectedNoInsurance, isMemberIdOptional }) => hasSelectedNoInsurance || isMemberIdOptional,
    },
    {
      field: 'isPrimaryMember',
      preset: ValidationRulePreset.required,
      shouldIgnore: hasSelectedNoInsurance,
    },
    {
      field: 'primaryMemberFirstName',
      preset: ValidationRulePreset.required,
      shouldIgnore: isPrimaryMember,
    },
    {
      field: 'primaryMemberLastName',
      preset: ValidationRulePreset.required,
      shouldIgnore: isPrimaryMember,
    },
    {
      field: 'primaryMemberBirthYear',
      preset: ValidationRulePreset.required,
      shouldIgnore: isPrimaryMember,
    },
    {
      field: 'primaryMemberBirthMonth',
      preset: ValidationRulePreset.required,
      shouldIgnore: isPrimaryMember,
    },
    {
      field: 'primaryMemberBirthDay',
      preset: ValidationRulePreset.required,
      shouldIgnore: isPrimaryMember,
    },
  ]);

interface PatientInfoParams {
  showReturningPatientToggle?: boolean;
}

export const PATIENT_INFO_VALIDATOR_CONFIG: FormValidatorConfig<PatientInfoParams> =
  createImmutableFormValidatorConfig([
    { field: 'firstName', preset: ValidationRulePreset.required },
    { field: 'lastName', preset: ValidationRulePreset.required },
    { field: 'month', preset: ValidationRulePreset.required },
    { field: 'day', preset: ValidationRulePreset.required },
    { field: 'year', preset: ValidationRulePreset.required },
    { field: 'sexAssignedAtBirth', preset: ValidationRulePreset.required },
    {
      field: 'isReturningPatient',
      preset: ValidationRulePreset.required,
      shouldIgnore: ({ showReturningPatientToggle }) => Boolean(!showReturningPatientToggle),
    },
  ]);
